var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand-book-illustrations-hero"},[_c('BrandBookSectionHeroImage',{attrs:{"src":"ILUSTRAÇÃO1.png"}}),_vm._v(" "),_c('BrandBookSectionHeroImage',{attrs:{"src":"ILUSTRAÇÃO2.png"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }